export default "__VITE_ASSET__Dc6RActL__"